import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, SupportedLanguage, normalizeLanguage } from '../../i18n';
import '../../styles/landing/LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
    const { i18n, t } = useTranslation();

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(e.target.value as SupportedLanguage);
    };

    return (
        <div className="language-switcher">
            <label htmlFor="language-select" className="visually-hidden">
                {t('language.label')}
            </label>
            <select
                id="language-select"
                value={normalizeLanguage(i18n.language)}
                onChange={handleChange}
                aria-label={t('language.label')}
            >
                {SUPPORTED_LANGUAGES.map((lang) => (
                    <option key={lang} value={lang}>
                        {t(`language.${lang}`)}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default LanguageSwitcher;
